export const TiposActionTypes = {
  API_RESPONSE_SUCCESS: '@@tipos-noticia/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@tipos-noticia/API_RESPONSE_ERROR',

  GET_TIPO: '@@tipos-noticia/GET_TIPO',
  LIST_TIPOS: '@@tipos-noticia/LIST_TIPOS',
  ADD_TIPO: '@@tipos-noticia/ADD_TIPO',
  UPDATE_TIPO: '@@tipos-noticia/UPDATE_TIPO',
  DELETE_TIPO: '@@tipos-noticia/DELETE_TIPO',

  RESET: '@@tipos-noticia/RESET'
}
